import axios from './axiosConfig';

import { API_URL } from "utils/constants";
import authHeader from "./auth-header";

const getRFQ = async (onDownloadProgress, onlyMy) => {
  const { data } = await axios.get(API_URL + "rfq/retrieve/", {
    onDownloadProgress: onDownloadProgress,
    headers: authHeader(),
    params: {"dispatched_trucks_only": onlyMy}
  });

  return data;
};

const getRFQWithId = async (onDownloadProgress, id, assign, onlyMy) => {
  const { data } = await axios.get(API_URL + `rfq/details/${id}`+`${assign ? `?assign=true`: ''}`, {
    onDownloadProgress: onDownloadProgress,
    headers: authHeader(),
    params: {"dispatched_trucks_only": onlyMy}
  });
  return data;
};

const skipRFQ = async (id) => {
  return await axios.patch(
    API_URL + "rfq/skip/",
    { RfqId: id },
    {
      headers: authHeader(),
    },
  );
};

const takeRFQ = async (id, forceTake) => {
  return await axios.patch(
    API_URL + "rfq/take/",
    { RfqId: id, forceTake },
    {
      headers: authHeader(),
    },
  );
};

const sendMsg = async (value) => {
  const chatUrl = process.env.REACT_APP_CHAT_URL;
  if (!chatUrl) {
    console.warn("REACT_APP_CHAT_URL not configured — skipping chat send");
    return;
  }
  return await axios.post(
    `${chatUrl}/chats/send_message/`,
    {
      body: {"message" :  value},
    },
  );
};

const noOptions = async (id) => {
  return await axios.patch(
    API_URL + "rfq/no_options/",
    { RfqId: id },
    {
      headers: authHeader(),
    },
  );
};

const postBid = async (data) => {
  return await axios.post(API_URL + "rfq/bid/", data, {
    headers: authHeader(),
  });
};

const getTrucksList = ({ truck_plate_number, state }) => {
  if(state?.dispatched) {
    return axios.get(API_URL + `trucks/units/${truck_plate_number}`, {
      headers: authHeader(),
    });
  } else {
    return axios.get(API_URL + `rfq/trucks/list/${truck_plate_number}`, {
      headers: authHeader(),
    });
  }
};

const getTruckCompact = async ({ truck_plate_number }) => {
  return await axios.get(API_URL + `rfq/trucks/compact/${truck_plate_number}`, {
    headers: authHeader(),
  });
};

const getTruckCompactDispatched = async ({ truck_plate_number }) => {
  return await axios.get(API_URL + `trucks/compact/${truck_plate_number}`, {
    headers: authHeader(),
  });
};

const getTruckDetails = async (id) => {
  return await axios.get(API_URL + `rfq/trucks/details/${id}/`, {
    headers: authHeader(),
  });
};
const getTruckDetailsDispatched = async (id) => {
  return await axios.get(API_URL + `trucks/${id}/`, {
    headers: authHeader(),
  });
};

/* Bids for RFQ */
const getBids = async () => {
  const { data } = await axios.get(API_URL + "rfq/bids/", {
    headers: authHeader(),
  });
  return data;
};
const getBidsDetails = async (id) => {
  const { data } = await axios.get(API_URL + `rfq/bid/details/${id}/`, {
    headers: authHeader(),
  });
  return data;
};

const getByOrderId = async (id) => {
  const { data } = await axios.get(API_URL + `rfq/assign_rfq/${id}/`, {
    headers: authHeader(),
  });
  return data;
};

const getCallPreview = async (rfqId, truckId) => {
  const { data } = await axios.post(API_URL + "ai-calling/calls/preview/", {
    rfq_id: rfqId,
    truck_id: truckId,
  }, {
    headers: authHeader(),
  });
  return data;
};

const createCall = async (rfqId, truckId, toNumber, dynamicVariables) => {
  const { data } = await axios.post(API_URL + "ai-calling/calls/create/", {
    rfq_id: rfqId,
    truck_id: truckId,
    to_number: toNumber,
    dynamic_variables: dynamicVariables,
  }, {
    headers: authHeader(),
  });
  return data;
};

const getRFQCalls = async (rfqId) => {
  const { data } = await axios.get(API_URL + `ai-calling/calls/rfq/${rfqId}/`, {
    headers: authHeader(),
  });
  return data;
};

const getCallDetail = async (callId) => {
  const { data } = await axios.get(API_URL + `ai-calling/calls/${callId}/`, {
    headers: authHeader(),
  });
  return data;
};

const quoteService = {
  getRFQ,
  getRFQWithId,
  skipRFQ,
  takeRFQ,
  noOptions,
  postBid,
  getTrucksList,
  getTruckCompact,
  getTruckDetails,
  getBids,
  getBidsDetails,
  getTruckDetailsDispatched,
  sendMsg,
  getTruckCompactDispatched,
  getByOrderId,
  getCallPreview,
  createCall,
  getRFQCalls,
  getCallDetail
};

export default quoteService;
